<template>
  <div>
    <LightGallery
      :images="images"
      :index="index"
      :disable-scroll="true"
      @close="index = null"
    />

    <div class="grid-list-images">
      <div
        class="grid-list-images-item"
        v-for="(img, i) in images"
        :key="i"
        @click="index = i"
      >
        <img :src="img + '?resize=1&w=600'" class="d-block" />
      </div>
    </div>
  </div>
</template>

<script>
import { LightGallery } from "vue-light-gallery";

export default {
  data: () => ({
    index: null,
  }),
  props: {
    images: {
      type: Array,
    },
  },
  components: {
    LightGallery,
  },
};
</script>

<style lang="scss" scoped>
.grid-list-images {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
  .grid-list-images-item {
    img {
      aspect-ratio: 16 / 10;
      cursor: pointer;
      object-fit: cover;
      -o-object-fit: cover;
      width: 100%;
    }
  }
}
</style>
